var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterior(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.765,
    height: 22.137,
    viewBox: "0 0 19.765 22.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M10.82,226.873c.24-1.067.425-2.112.715-3.127a9.406,9.406,0,0,1,2.166-3.611,8.663,8.663,0,0,0,2.28-3.905c.217-1.032.294-2.093.424-3.144.037-.3.01-.613.063-.91a1.625,1.625,0,0,1,1.581-1.369c.561-.019,1.124-.017,1.686,0a1.1,1.1,0,0,1,1.078,1.4c-.678,2.6-1.374,5.2-2.067,7.8q-1.388,5.207-2.787,10.407a3.3,3.3,0,0,1-3.284,2.514c-4.042.006-4.649,0-8.691,0a1.831,1.831,0,0,1-1.513-.744,5.729,5.729,0,0,1-1.344-2.56,1.894,1.894,0,0,1,.714-1.916,5.5,5.5,0,0,1,2.542-1.049,15,15,0,0,1,3.658-.151c1.005.081,1.813.227,2.78.364",
    transform: "translate(-1.088 -210.793)",
    fill: "#161615"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterior);
export default __webpack_public_path__ + "static/media/interior.329d4498dff795bf36ce087f97555ae2.svg";
export { ForwardRef as ReactComponent };